<template>
  <div class="message-center-wrapper">
    <div class="message-header">
      <h3 class="section-title">消息中心</h3>
      <span class="message-count">{{ allData.length }} 条消息</span>
    </div>
    
    <div class="message-list" v-if="allData.length > 0">
      <el-collapse accordion class="modern-collapse">
        <el-collapse-item v-for="item in displayList" :key="item.id">
          <template slot="title">
            <div class="message-title-row" @click="readMessage(item.id)">
              <div class="message-info">
                <span class="unread-dot" v-if="item.readStatus !== 1"></span>
                <p class="message-title">{{ item.title }}</p>
              </div>
              <div class="message-status">
                <el-tag v-if="item.readStatus === 1" size="small" type="info" effect="plain">已读</el-tag>
                <el-tag v-else size="small" type="danger" effect="light">未读</el-tag>
              </div>
            </div>
          </template>
          <div class="message-content">
            <div class="content-text">{{ item.content }}</div>
            <div class="content-time">
              <i class="el-icon-time"></i>
              {{ item.createTime }}
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      
      <!-- 加载更多按钮 -->
      <div class="load-more-wrapper" v-if="hasMore">
        <el-button type="text" class="load-more-btn" @click="loadMore">
          <i class="el-icon-arrow-down"></i>
          加载更多
        </el-button>
      </div>
      <div class="no-more" v-else-if="allData.length > pageSize">
        已加载全部
      </div>
    </div>

    <div class="empty-state" v-else>
      <i class="el-icon-message"></i>
      <p>暂无消息</p>
    </div>
  </div>
</template>

<script>
import {
  getUserNotice,
  read
} from "@/api/index.js"

export default {
  data() {
    return {
      allData: [],
      pageSize: 5,
      displayCount: 5
    }
  },
  computed: {
    displayList() {
      return this.allData.slice(0, this.displayCount)
    },
    hasMore() {
      return this.displayCount < this.allData.length
    }
  },
  methods: {
    getInfo() {
      getUserNotice().then(res => {
        if (res.code === "0000") {
          this.allData = res.data.list
        }
      })
    },
    readMessage(id) {
      read(id).then(res => {
        if (res.code === "0000") {
          this.getInfo()
        }
      })
    },
    loadMore() {
      this.displayCount += this.pageSize
    }
  },
  mounted() {
    this.getInfo()
  }
}
</script>

<style lang="scss" scoped>
.message-center-wrapper {
  padding: 0 30px;
}

.message-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.section-title {
  font-size: 18px;
  color: #303133;
  margin: 0;
  font-weight: 500;
  padding-left: 12px;
  border-left: 3px solid #409EFF;
}

.message-count {
  font-size: 13px;
  color: #909399;
}

.message-list {
  background: #FFFFFF;
}

.modern-collapse ::v-deep .el-collapse-item {
  margin-bottom: 12px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #EBEEF5;
  transition: all 0.3s ease;

  &:hover {
    border-color: #D4E5F7;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.08);
  }
}

.modern-collapse ::v-deep .el-collapse-item__header {
  height: 56px;
  line-height: 56px;
  padding: 0 20px;
  background: #FAFBFC;
  border-bottom: none;
  transition: background 0.3s ease;

  &:hover {
    background: #F5F7FA;
  }

  &.is-active {
    background: #F0F7FF;
  }
}

.modern-collapse ::v-deep .el-collapse-item__wrap {
  border-top: 1px solid #EBEEF5;
}

.modern-collapse ::v-deep .el-collapse-item__content {
  padding: 0;
}

.modern-collapse ::v-deep .el-collapse-item__arrow {
  color: #909399;
}

.message-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 10px;
}

.message-info {
  display: flex;
  align-items: center;
  flex: 1;
}

.unread-dot {
  width: 8px;
  height: 8px;
  background: #F56C6C;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
}

.message-title {
  font-size: 14px;
  color: #303133;
  margin: 0;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 500px;
}

.message-status {
  flex-shrink: 0;
  margin-left: 20px;
}

.message-content {
  padding: 20px;
  background: #FFFFFF;
}

.content-text {
  font-size: 14px;
  color: #606266;
  line-height: 1.8;
  margin-bottom: 16px;
}

.content-time {
  font-size: 13px;
  color: #909399;
  display: flex;
  align-items: center;

  i {
    margin-right: 6px;
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  color: #C0C4CC;

  i {
    font-size: 48px;
    margin-bottom: 16px;
  }

  p {
    font-size: 14px;
    margin: 0;
  }
}

.load-more-wrapper {
  text-align: center;
  padding: 24px 0;
}

.load-more-btn {
  color: #409EFF;
  font-size: 14px;
  padding: 12px 40px;
  border-radius: 22px;
  border: 1px solid #409EFF;
  background: #FFFFFF;
  transition: all 0.3s ease;

  i {
    margin-right: 8px;
    transition: transform 0.3s ease;
  }

  &:hover {
    background: #409EFF;
    color: #FFFFFF;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);

    i {
      transform: translateY(2px);
    }
  }
}

.no-more {
  text-align: center;
  padding: 20px 0;
  color: #C0C4CC;
  font-size: 13px;
}
</style>
